import { render, staticRenderFns } from "./ModalFormPartida.vue?vue&type=template&id=2ed71b48&scoped=true"
import script from "./ModalFormPartida.vue?vue&type=script&lang=js"
export * from "./ModalFormPartida.vue?vue&type=script&lang=js"
import style0 from "./ModalFormPartida.vue?vue&type=style&index=0&id=2ed71b48&prod&scoped=true&lang=css"
import style1 from "./ModalFormPartida.vue?vue&type=style&index=1&id=2ed71b48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed71b48",
  null
  
)

export default component.exports